import React from "react";
import { useTranslation } from "react-i18next";
import StyledDropdown from "src/components/reusable/StyledDropdown";
import type { NotificationOption } from "../Types/NotificationTypes";
import "../Styles/DigestFrequencyCard.scss";

interface DigestFrequencyCardProps {
  digestFrequency: string;
  frequencyOptions: NotificationOption[];
  digestNote: string;
}

const DigestFrequencyCard: React.FC<DigestFrequencyCardProps> = ({
  digestFrequency,
  frequencyOptions,
  digestNote,
}) => {
  const { t } = useTranslation();

  return (
    <div className="digest-frequency-card">
      <div className="digest-frequency-left">
        <div className="digest-frequency-info">
          <span className="digest-frequency-title">
            {t("notificationPreferences.digestFrequency.title", {
              defaultValue: "Notification Digest Frequency",
            })}
          </span>
          <span className="digest-frequency-subtitle">
            {t("notificationPreferences.digestFrequency.subtitle", {
              defaultValue: "Control how often you receive rolled-up alerts.",
            })}
          </span>
          <span className="digest-frequency-note">{digestNote}</span>
        </div>
      </div>

      <StyledDropdown
        value={digestFrequency}
        disabled
        aria-label={t("notificationPreferences.digestFrequency.valueAriaLabel", {
          defaultValue: "Current digest frequency (fixed)",
        })}
        className="digest-frequency-select"
        options={frequencyOptions}
      />
    </div>
  );
};

export default DigestFrequencyCard;
